import React, { useState } from 'react';

import { formatToFixedSeparateThousands } from 'Helpers/formatService';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import TextButton from 'CommonComponents/TextButton';
import Tooltip from 'CommonComponents/Tooltip';

import { useToast } from 'Hooks/useToast';

import CirclePlusIcon from 'Assets/icons/circle-plus.svg';
import EditIcon from 'Assets/icons/edit.svg';
import EyeIcon from 'Assets/icons/eye.svg';
import TrashIcon from 'Assets/icons/trash.svg';

export default function SuppliersIndexTableRow(props) {
    const [showedContracts, setShowedContracts] = useState(false);
    const [contracts, setContracts] = useState([]);
    const [loading, setLoading] = useState(false);

    const toast = useToast();

    const fetchContracts = () => {
        setLoading(true);
        setShowedContracts(true);
        axios
            .get(props.supplier.detailsUrl)
            .then((response) => {
                setContracts(response.data.contracts);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const showContracts = () => {
        if (showedContracts) {
            setShowedContracts(false);
        } else {
            fetchContracts();
        }
    };

    return (
        <>
            <tr key={props.supplier.id} className="tw-cursor-pointer">
                <td className={props.supplier.deleted_on_erp ? 'text-danger' : ''} onClick={showContracts}>
                    <Tooltip
                        placement="bottom"
                        allowTooltip={!!props.supplier.deleted_on_erp}
                        tooltipContent={$t('This supplier is no longer in ERP System')}
                        tooltipType="text"
                    >
                        <span>{props.supplier.name}</span>
                    </Tooltip>
                </td>
                <td className={props.supplier.deleted_on_erp ? 'text-danger' : ''} onClick={showContracts}>
                    {props.supplier.code}
                </td>
                <td onClick={showContracts}>{props.supplier.supplier_contact?.name || '-'}</td>
                <td onClick={showContracts}>{props.supplier.supplier_contact?.email || '-'}</td>
                <td onClick={showContracts}>{props.supplier.location_object != null ? props.supplier.location_object.name : ''}</td>
                <td onClick={showContracts}>{props.supplier.post_code || ''}</td>
                <td className="inbud-numeric-cell" onClick={showContracts}>
                    {formatToFixedSeparateThousands(props.supplier.totalContracts || 0, ',')}
                </td>
                <td>
                    <div className="tw-flex tw-items-center tw-gap-x-3">
                        {(props.canBeEdited || props.supplier.sponsortier_id) && (
                            <TextButton variant="primary" onClick={() => props.clickRow(props.supplier)}>
                                <EditIcon className="tw-w-3 tw-h-3" /> {$t('Edit')}
                            </TextButton>
                        )}
                        <TextButton variant="danger" onClick={() => props.deleteRow(props.supplier)}>
                            <TrashIcon className="tw-w-3 tw-h-3" />
                            {$t('Delete')}
                        </TextButton>
                    </div>
                </td>
            </tr>
            {showedContracts && (
                <tr>
                    {loading && (
                        <td colSpan="8">
                            <LoadingSpinner />
                        </td>
                    )}
                    {!loading && (
                        <td colSpan="8">
                            <h5 className="table__header">{$t('Contracts')}:</h5>
                            <div className="inbud-table_wrapper">
                                <table className="inbud-table">
                                    <thead>
                                        <tr>
                                            <th>{$t('Contract Reference Code')}</th>
                                            <th>{$t('Expense Description')}</th>
                                            <th>{$t('Value')}</th>
                                            <th>{$t('Terms Actions')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {contracts.map((contract) => {
                                            return (
                                                <tr key={contract.id}>
                                                    <td>{contract.contract_reference}</td>
                                                    <td>
                                                        {contract.purchase_orders.map((order) => {
                                                            return (
                                                                <p key={order.id}>
                                                                    {order.code}{' '}
                                                                    {order.code && order.description ? ': ' + order.description : order.description}
                                                                </p>
                                                            );
                                                        })}
                                                    </td>
                                                    <td>{contract.cashflow?.total ? formatToFixedSeparateThousands(contract.cashflow.total) : '-'}</td>
                                                    <td>
                                                        <div className="tw-flex tw-items-center tw-gap-x-3">
                                                            {contract.term_exists ? (
                                                                <>
                                                                    <TextButton variant="primary" onClick={() => props.onViewTerms(contract)}>
                                                                        <EyeIcon className="tw-w-3 tw-h-3" /> {$t('View')}
                                                                    </TextButton>
                                                                    <TextButton variant="primary" onClick={() => props.onEditTerms(contract)}>
                                                                        <EditIcon className="tw-w-3 tw-h-3" />
                                                                        {$t('Edit')}
                                                                    </TextButton>
                                                                </>
                                                            ) : (
                                                                <TextButton variant="primary" onClick={() => props.onAddTerms(contract)}>
                                                                    <CirclePlusIcon className="tw-w-3 tw-h-3" /> {$t('Add Terms')}
                                                                </TextButton>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </td>
                    )}
                </tr>
            )}
        </>
    );
}
